import React from 'react'
import { Grid as GridBase, styled } from '@mui/material'

export const Root = styled('div')`
  grid-area: heading-filters;
  width: 100%;
`
export const Grid = styled(({ textAlign, ...props }) => <GridBase {...props} />)`
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  text-align: ${props => props.textAlign || 'initial'};
  width: 100%;
`
export const NotificationWrapper = styled('div')`
  grid-area: notificationBottom;
`
